module.exports = __webpack_public_path__ + "media/country_flags/ga-c6d1de2a.png";